import { type LabelHTMLAttributes, type ReactElement, type ReactNode } from "react";

import { cn } from "../utils/cn";

export interface LabelProps extends Omit<LabelHTMLAttributes<HTMLLabelElement>, "children"> {
  children: ReactNode;
  required?: boolean | undefined;
  hint?: ReactNode | undefined;
}

export function Label({ children, required, hint, className, ...rest }: LabelProps): ReactElement {
  return (
    <div className="mb-2 flex items-baseline justify-between">
      <label
        className={cn("text-sm font-medium text-text-secondary", className)}
        {...rest}
      >
        {children}
        {required && (
          <span aria-hidden="true" className="ml-0.5 text-danger-500">
            *
          </span>
        )}
      </label>
      {hint && <span className="text-xs text-text-tertiary">{hint}</span>}
    </div>
  );
}
